// src/admin/ProjectsContext.jsx
import React, { createContext, useState, useEffect } from "react";
import { projects as mockProjects } from "../mock";

export const ProjectsContext = createContext();

export const ProjectsProvider = ({ children }) => {
  const [projects, setProjects] = useState(() => {
    const saved = localStorage.getItem("projectsData");
    return saved ? JSON.parse(saved) : mockProjects;
  });

 useEffect(() => {
  localStorage.setItem("projectsData", JSON.stringify(projects));
}, [projects]);

useEffect(() => {
  setProjects(mockProjects);
}, []);

  const updateProject = (updatedProject) => {
    setProjects((prev) =>
      prev.map((p) => (p.id === updatedProject.id ? updatedProject : p))
    );
  };

  const deleteProject = (projectId) => {
  setProjects((prev) => prev.filter((p) => p.id !== projectId));
};


  const addProject = (newProject) => {
    setProjects((prev) => [...prev, newProject]);
  };

  return (
    <ProjectsContext.Provider
      value={{ projects, updateProject, deleteProject, addProject }}
    >
      {children}
    </ProjectsContext.Provider>
  );
};